<template>
  <div class="app-consumption-progress list-content">
    <SimonModal
      :is-visible="showConsumptionModal"
      @hide="showConsumptionModal = false"
      id="consumption-info-modal"
      hidden-footer
    >
      <template v-if="this.getTariffVolume() !== null" v-slot:modalTitle>
        <h4><slot name="txtCompositionHeadline">Zusammensetzung</slot></h4>
      </template>
      <VolumeComposition
        :booked-tariff="tariffs.bookedTariff"
        :booked-tariff-options="bookedTariffOptions"
        :separate-consumptions="separateListingConsumptions"
        :units="units"
      >
      </VolumeComposition>
    </SimonModal>
    <SimonModal
      :is-visible="showPlayInfoModal"
      @hide="showPlayInfoModal = false"
      id="play-info-modal"
    >
      <slot name="txtPlayInfoModal"></slot>
    </SimonModal>
    <SimonModal
      :is-visible="showBreakModalActive"
      @hide="showBreakModalActive = false"
      id="tariff-break-modal-deactivate"
      show-footer-buttons
      @btnLeft="showBreakModalActive = false"
      @btnRight="deactivateTariffBreak"
      :btn-left-title="getSlotText('txtTarifBreakModalCTACancel', 'Abbrechen')"
      :btn-right-title="getSlotText('txtTarifBreakModalCTASubmitActive','Pause aufheben')"
    >
      <template v-slot:modalTitle>
        <h4><slot name="txtTarifBreakModalTitleActive"></slot></h4>
      </template>
      <slot name="txtTarifBreakModalInfoActive"></slot>
    </SimonModal>
    <div :class="{'activeContract': (!this.contractPauseActive && !this.contractPauseCreated),'content-card': true}">
      <div class="inner-content" v-if="!showError && !this.loading">
        <div v-if="this.contractPauseActive" class="tariff-break-content-play-button">
          <h4><slot name="txtHeadlineConsumptionBreak">Dein Vertrag ist pausiert</slot></h4>
          <div class="consumption-progress-box">
            <div @click="showBreakModalActive = true"><slot name="svgTarifBreakActiveCTAPlayButton"></slot></div>
            <div class="info-icon" @click="showPlayInfoModal=true"><slot name="svgTarifBreakActiveCTAInfoIcon"></slot></div>
          </div>
        </div>
        <div v-else class="content">
          <h4><slot name="txtHeadlineConsumption">Dein Datenvolumen</slot></h4>
          <div v-if="!this.contractTerminated && this.maxConsumptionExpirationDate !== ''" class="consumption-period-info">
            <dyn-slot :slot-data="slotData"><slot name="txtConsumptionPeriod">Verfügbar bis xx.xx.xxxx</slot></dyn-slot>
          </div>
          <div class="consumption-progress-box" :class="{terminated: this.contractTerminated, disabled: this.loading, low: (this.lowVolume && !this.contractTerminated), novolume: (this.noVolumeLeft && !this.contractTerminated)}">
            <div class="graph-wrapper">
              <svg id="consumption-progress-graph" class="graph" :class="{terminated: this.contractTerminated, disabled: this.loading}" width="200" height="200" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
                <linearGradient class="low-volume-gradient" id="lowVolumeGradient">
                  <stop class="start" offset="75%"></stop>
                  <stop class="end" offset="100%"></stop>
                </linearGradient>
                <circle id="consumption-progress-bar-remains" class="bar-remain" r="90" cx="98" cy="98" fill="transparent" stroke-dasharray="565.48" stroke-dashoffset="0"></circle>
                <circle id="consumption-progress-bar-used" class="bar-used" r="90" cx="98" cy="98" fill="transparent" stroke-dasharray="565.48" stroke-dashoffset="1130.96"></circle>
              </svg>
            </div>
            <div id="volContent" :class="{terminated: this.contractTerminated, disabled: this.loading, low: (this.lowVolume && !this.contractTerminated), novolume: (this.noVolumeLeft && !this.contractTerminated)}">
              <a class="info-link-icon" :class="{white: this.noVolumeLeft}" @click="showConsumptionModal = true"></a>
              <div v-if="!this.contractTerminated">
                <div>
                  <b-row class="volume">
                    <b-col class="volume-count">
                      <div>{{ formatDecimal(parseFloat(this.accumulatedConsumptions.left).toFixed(2), 2) }}</div>
                      <div class="volume-unit">{{ units['GB'] }}</div>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col class="volume-left info"><slot name="txtVolumeLeftInfo">verbleibend von</slot></b-col>
                  </b-row>
                  <b-row>
                    <b-col class="volume-left amount">{{ this.accumulatedConsumptions.max }} {{ units['GB'] }}</b-col>
                  </b-row>
                </div>
              </div>
              <div v-else>
                <div>
                  <b-row class="volume">
                    <b-col class="volume-count">
                      <div>0</div>
                      <div class="volume-unit">{{ units['GB'] }}</div>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col class="volume-left info"><slot name="txtVolumeLeftInfo">verbleibend von</slot></b-col>
                  </b-row>
                  <b-row>
                    <b-col class="volume-left amount">0{{ units['GB'] }}</b-col>
                  </b-row>
                </div>
              </div>
            </div>
          </div>
          <div v-if="!this.contractTerminated" class="comsumption-info">
            <div v-if="this.lowVolume && !this.hasDayFlatConsumption() && !this.hasActiveBucketPromotion" class="info-low-volume"><slot name="txtConsumptionInfoLowVolume"></slot></div>
            <div v-if="this.noVolumeLeft && !this.hasDayFlatConsumption() && !this.hasActiveBucketPromotion" class="info-no-volume"><slot name="txtConsumptionInfoNoVolume"></slot></div>
            <div v-if="this.lowVolume && this.hasBookableTariffOptions()" class="cta-options">
              <button class="button-border" @click="this.scrollToOptions"><slot name="txtConsumptionInfoCTAOptions"></slot></button>
            </div>
          </div>
        </div>
        <div v-if="!this.contractPauseActive && !this.contractTerminated && this.separateListingConsumptions.length > 0">
          <div v-for="(con, index) in separateListingConsumptions" :key="con.id + ' ' + index" class="separate-consumption-progress" :class="{terminated: contractTerminated, disabled: loading}">
            <div class="separate-consumption-txt">
              <span> {{con.name}} </span>
              {{con.left}}/{{con.max}}{{units[con.unit]}}</div>
            <div class="separate-consumption-status-bar">
              <b-progress :value="con.left" :max="con.max" class="mb-3"></b-progress>
            </div>
            <div class="separate-consumption-end"><slot name="txtSeparateConsumptionEnd">Option gültig bis</slot>
              <span v-if="String(con.id) === String(dayFlatTariffOptionId)"> {{dateTimeFormatter(new Date(con.expirationDate))}}</span>
              <span v-else> {{dateFormatter(new Date(con.expirationDate))}}</span>
<!--              Priorisierung des Verbrauchs momentan noch nicht zuverlässig, daher wird das via CSS ausgeblendet-->
              <span class="separate-consumption-priority" :class="{promo: con.expiresWithinCurrentPeriod}" v-if="String(index) === String(0)">
                <slot v-if="String(con.id) === String(dayFlatTariffOptionId) || con.expiresWithinCurrentPeriod" name="txtSeparateConsumptionPriority">, wird zuerst verbraucht</slot>
              </span>
            </div>
          </div>
        </div>
        <div v-if="this.contractPauseCreated" class="tariff-break-section">
          <div class="tariff-break-txt">
            <dyn-slot :slot-data="slotData"><slot name="txtTarifBreakInfoTxtCreated">Dein Vertrag wird ab dem XX.XX.XXXX pausiert.</slot></dyn-slot>
          </div>
          <button @click="deactivateTariffBreak">
            <slot name="txtTarifBreakCTACreated">Pause widerrufen</slot>
          </button>
        </div>
        <div v-if="this.contractPauseActive" class="tariff-break-content">
          <div class="tariff-break-txt">
            <dyn-slot :slot-data="slotData"><slot name="txtTarifBreakInfoTxtActive">Deine Vertragspause läuft bis zum XX.XX.XXXX. Du kannst sie jederzeit aufheben.</slot></dyn-slot>
          </div>
          <button @click="showBreakModalActive = true">
            <slot name="txtTarifBreakCTAActive">Pause aufheben</slot>
          </button>
        </div>
      </div>
      <div v-if="showError" v-html="this.errorMsg" class="error-box"></div>
    </div>
  </div>
</template>

<script>
import { wrapQuery } from '@/helper/wrapGQLQuery'
import gql from 'graphql-tag'
import debounce from 'lodash.debounce'
import formatDecimal from '@/mixins/formatters/formatDecimal'
import dateFormatter from '@/mixins/formatters/dateFormatter'
import { splitError } from '@/helper/splitError'
import syncProperty from '@/mixins/syncProperty'
import customerContractState from '@/mixins/customerContractState'
import { mapActions, mapGetters } from 'vuex'
import beErrors from '@/mixins/beErrors'
import SimonModal from '@/components/modal/SimonModal.vue'
import VolumeComposition from '@/components/process/generic/Consumption/VolumeComposition.vue'

export default {
  name: 'ConsumptionProgress',
  components: { VolumeComposition, SimonModal },
  data () {
    return {
      loading: true,
      loadingConsumptions: true,
      loadingBookedTariffOptions: true,
      showError: false,
      errorMsg: '',
      dayFlatTariffOptionId: 3040138,
      bucketPromotions: [13003, 7777, 25201, 25202, 13218, 25509, 14102, 26301, 14601, 26501],
      validConsumptionTypes: ['DATA', 'ROAMING_DATA', 'ROAMING_SMS_AND_VOICE', 'DAY_FLAT_DATA'],
      units: {
        QUANTITY: ' Min./SMS',
        MINUTE: ' Minuten',
        GB: ' GB',
        MB: ' MB'
      },
      showConsumptionModal: false,
      showPlayInfoModal: false,
      showBreakModalActive: false,
      lowVolume: false,
      lowVolumeThreshold: 0.2,
      noVolumeLeft: false,
      allConsumptions: [],
      tariffs: {
        bookedTariff: null
      },
      tariffoptions: {
        bookedTariffoptions: null,
        bookableTariffoptions: null
      }
    }
  },
  mixins: [
    formatDecimal,
    dateFormatter,
    syncProperty('loaded', 'loaded_'),
    customerContractState(),
    beErrors
  ],
  created () {
    this.getActivePromotions()
  },
  mounted () {
    this.loading = true
    this.loadingConsumptions = true
    this.loadingBookedTariffOptions = true
  },
  watch: {
    '$store.state.tariffOptions.bookedOptionUpdateTriggerValue': function () {
      this.refetchData()
    }
  },
  updated: debounce(function () {
    this.$nextTick(() => {
      this.formatCirclePercent()
    })
  }, 1000),
  methods: {
    ...mapActions('tariffBreak', [
      'deleteContractPause'
    ]),
    ...mapActions('promotion/activePromotions', [
      'getActivePromotions'
    ]),
    checkLoadingStatus () {
      this.loading = (this.loadingConsumptions || this.loadingBookedTariffOptions)
      if (!this.loading) {
        this.loaded_ = true
        this.$emit('loaded')
      }
    },
    getTariffVolume () {
      if (typeof this.tariffs.bookedTariff?.volumes !== 'undefined' && typeof this.tariffs.bookedTariff.volumes[0] !== 'undefined') {
        return this.tariffs.bookedTariff.volumes[0]
      }
      return null
    },
    getSpecificConsumption (type, id = null) {
      let consumptions = []
      if (typeof this.allConsumptions?.detailedConsumptions?.length !== 'undefined') {
        this.allConsumptions.detailedConsumptions.forEach(consumption => {
          if (consumption?.type === type && (id === null || parseInt(consumption?.id) === parseInt(id))) {
            if (consumption.consumptionDetails && consumption.consumptionDetails.length > 0) {
              consumptions = consumption.consumptionDetails
            }
          }
        })
      }
      return consumptions
    },
    hasDayFlatConsumption () {
      let found = false
      const consumptions = this.getSpecificConsumption('Tariffoption', this.dayFlatTariffOptionId)
      found = consumptions.length > 0
      return found
    },
    formatCirclePercent () {
      if (!this.loading && !this.showError && !this.contractPauseActive) {
        const progessCircle = document.getElementById('consumption-progress-bar-used')
        const maxVolume = this.accumulatedConsumptions.max
        const radius = progessCircle.getAttribute('r')
        const diameter = Math.PI * (radius * 2)

        let volumeLeft = this.accumulatedConsumptions.left
        if (isNaN(volumeLeft) || volumeLeft > maxVolume) {
          volumeLeft = maxVolume
        } else {
          if (volumeLeft < 0) {
            volumeLeft = 0
          }
          this.noVolumeLeft = (volumeLeft === 0)
          if (!this.noVolumeLeft) {
            const usedPct = ((maxVolume - volumeLeft) / maxVolume)
            const remainPct = 1 - usedPct
            this.lowVolume = (remainPct < this.lowVolumeThreshold)
            progessCircle.style.strokeDashoffset = (diameter + Math.floor(remainPct * diameter))
          }
        }
      }
    },
    dateTimeFormatter (datetime) {
      return this.$config.calendar.formatter.dateShortTimeFormatter.format(datetime)
    },
    scrollToOptions () {
      window.jQuery([document.documentElement, document.body]).animate({
        scrollTop: window.jQuery('.app-tariff-options-overview-wrapper').offset().top - 50
      }, 500)
    },
    refetchData () {
      this.$apollo.queries.consumptions.refetch()
      this.$apollo.queries.bookedTariffOptions.refetch()
    },
    deactivateTariffBreak () {
      this.deleteContractPause({})
        .then((response) => {
          if (response?.success === true) {
            this.reQueryContractState()
            this.errorMsg = ''
            this.successToast(this.deleteSuccessToastMsg)
          }
          this.showBreakModalActive = false
        }).catch((e) => {
          this.showError = true
          const errMsg = this.beErrorGetLastMessage()
          if (errMsg !== null) {
            const data = {
              type: 'technical',
              message: errMsg.substring(0, 50),
              code: this.beErrorGetLastErrorCode()
            }
            if (typeof window.trackingNS?.track?.tracking === 'function') {
              window.trackingNS.track.tracking('error', data)
            }
          }
        })
    },
    hasBookableTariffOptions () {
      let available = false
      if (this.tariffoptions?.bookableTariffoptions?.bookableTariffoptions) {
        this.tariffoptions?.bookableTariffoptions?.bookableTariffoptions.forEach((option) => {
          if (!option.conflictWithCurrent) {
            available = true
          }
        })
      }
      return available
    }
  },
  computed: {
    hasActiveBucketPromotion () {
      return typeof (this.flattenedConsumptions.find(item => this.bucketPromotions.includes(parseInt(item.id)))) !== 'undefined'
    },
    bookedTariffOptions () {
      return this.tariffoptions.bookedTariffoptions?.bookedTariffoptions || []
    },
    accumulatedConsumptions () {
      const consumption = {
        consumed: 0,
        max: 0,
        left: 0
      }
      if (this.flattenedConsumptions.length > 0) {
        this.flattenedConsumptions.forEach(item => {
          if (!item.expiresWithinCurrentPeriod && !item.displaySeparately) {
            consumption.consumed += item.consumed
            consumption.max += item.max
            consumption.left += item.left
          }
        })
      }
      return consumption
    },
    flattenedConsumptions () {
      const consumptions = []

      this.allConsumptions?.detailedConsumptions?.forEach(consumption => {
        let toAdd = false
        let item = {
          id: consumption.id,
          name: consumption.name,
          type: consumption.type
        }
        // im Falle einer Promo wird auf activePromos gemappt, damit die description statt dem name angezeigt werden kann
        let promoConsumption = null
        if (this.volumeIncentivesForCurrentTariff && item.type === 'Promotion') {
          promoConsumption = this.volumeIncentivesForCurrentTariff.find(promo => (String(promo.promotionId) === item.id))
        }
        if (promoConsumption) {
          item.name = promoConsumption.description
        }
        consumption.consumptionDetails?.forEach(consumptionDetail => {
          if (this.validConsumptionTypes.includes(consumptionDetail.type)) {
            item = {
              ...item,
              consumed: consumptionDetail.consumed,
              left: consumptionDetail.left,
              max: consumptionDetail.max,
              expirationDate: consumptionDetail.expirationDate,
              unit: consumptionDetail.unit,
              expiresWithinCurrentPeriod: consumptionDetail.expiresWithinCurrentPeriod,
              displaySeparately: consumptionDetail.displaySeparately
            }
            toAdd = true
          }
        })
        if (toAdd) {
          consumptions.push(item)
        }
      })
      return consumptions
    },
    separateListingConsumptions () {
      const separateConsumptions = []
      this.flattenedConsumptions.forEach(item => {
        // special options, promotions that expires within the current period and bucket promotions are reported individually
        if (item.displaySeparately || item.expiresWithinCurrentPeriod) {
          separateConsumptions.push(item)
        }
      })
      separateConsumptions.sort((a, b) => (a.expirationDate > b.expirationDate) ? 1 : ((b.expirationDate > a.expirationDate) ? -1 : 0))
      return separateConsumptions
    },
    maxConsumptionExpirationDate () {
      let maxExpDate = ''
      this.flattenedConsumptions.forEach(item => {
        // only tariff-consumption for exp-date
        if (item.type === 'Tariff') {
          maxExpDate = item.expirationDate
        }
      })
      if (maxExpDate !== '') {
        maxExpDate = this.dateFormatter(new Date(maxExpDate))
      }
      return maxExpDate
    },
    slotData () {
      return {
        endDate: this.dateFormatter(new Date(this.contractPauseEndDate)),
        startDate: this.dateFormatter(new Date(this.contractPauseStartDate)),
        volumeEndDate: this.maxConsumptionExpirationDate
      }
    },
    deleteSuccessToastMsg () {
      if (this.contractPauseCreated) {
        return this.getSlotText('txtTarifWithdrawBreakToastSuccessMsg')
      }
      if (this.contractPauseActive) {
        return this.getSlotText('txtTarifCancelBreakToastSuccessMsg')
      }
      return ''
    },
    ...mapGetters('promotion/activePromotions', [
      'activePromotions',
      'volumeIncentivesForCurrentTariff'
    ]),
    ...mapGetters('promotion', [
      'promotions'
    ])
  },
  apollo: {
    consumptions: function () {
      return wrapQuery(
        gql`query consumptions {
              allConsumptions: consumptions  {
                detailedConsumptions {
                  consumptionDetails: consumptions {
                    consumed,
                    expirationDate,
                    left,
                    max,
                    type,
                    unit,
                    expiresWithinCurrentPeriod,
                    displaySeparately
                  }
                  id,
                  isFlat,
                  name,
                  type
                }
              }
            }`, this, 'allConsumptions', {}, (data) => {
          this.loadingConsumptions = false
          this.checkLoadingStatus()
        },
        {
          fetchPolicy: 'no-cache'
        },
        (error) => {
          this.loadingConsumptions = false
          this.checkLoadingStatus()
          this.showError = true
          this.errorMsg = this.beErrorGetLastMessage()
          if (this.errorMsg === '') {
            splitError(error).forEach(e => {
              this.errorMsg = e.message
            })
          }
          if (!this.showError) {
            const data = {
              type: 'technical',
              message: this.errorMsg
            }
            if (typeof window.trackingNS?.track?.tracking === 'function') {
              window.trackingNS.track.tracking('error', data)
            }
          }
        }
      )
    },
    bookedTariffOptions: function () {
      return wrapQuery(
        gql`query bookedTariffOptions {
          tariffs{
            bookedTariff {
              tariffState
              name
              basicFee formattedBasicFee
              terminationDate
              renewContractDate
              contractPeriod
              changeTariffDate
              volumes {
                formattedUnit
                type
                amount
                unit
              }
            }
          }
          tariffoptions{
            bookedTariffoptions {
              bookedTariffoptions {
                automaticExtension
                tariffoptionId
                name
                details
                statusKey
                expirationDate
                activeRuntime {
                  endOfRuntime
                  startOfRuntime
                }
                duration {
                  amount
                  unit
                  formattedUnit
                }
                volumes {
                  formattedUnit
                  type
                  amount
                  unit
                }
              }
            }
            bookableTariffoptions {
              bookableTariffoptions {
                tariffoptionId
                conflictWithCurrent
              }
            }
          }
        }`, this, ['tariffs', 'tariffoptions'], {}, (data) => {
          this.loadingBookedTariffOptions = false
          this.checkLoadingStatus()
        },
        {
          fetchPolicy: 'no-cache'
        },
        (error) => {
          this.loadingBookedTariffOptions = false
          this.checkLoadingStatus()
          this.showError = true
          this.errorMsg = this.beErrorGetLastMessage()
          if (this.errorMsg === '') {
            splitError(error).forEach(e => {
              this.errorMsg = e.message
            })
          }
          if (!this.showError) {
            const data = {
              type: 'technical',
              message: this.errorMsg
            }
            if (typeof window.trackingNS?.track?.tracking === 'function') {
              window.trackingNS.track.tracking('error', data)
            }
          }
          this.showError = true
        }
      )
    }
  }
}
</script>
